import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

import { ButtonBlack, DateInput } from '../../../reusable';

const SpecialHoursReport = ({ isOpen, onClose, specialHours }) => {
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [counts, setCounts] = useState({ PLANNED: 0, UNPLANNED: 0 });

  const calculateCounts = (from, to) => {
    if (!from || !to) {
      setCounts({ PLANNED: 0, UNPLANNED: 0 });
      return;
    }

    const fromDateObj = new Date(from);
    const toDateObj = new Date(to);

    const plannedCount = specialHours.filter((specialHour) => {
      if (!specialHour.date || !specialHour.type) return false;
      const specialDate = new Date(specialHour.date);
      return specialHour.type === 'PLANNED'
        && specialDate >= fromDateObj
        && specialDate <= toDateObj;
    }).length;

    const unplannedCount = specialHours.filter((specialHour) => {
      if (!specialHour.date || !specialHour.type) return false;
      const specialDate = new Date(specialHour.date);
      return specialHour.type === 'UNPLANNED'
        && specialDate >= fromDateObj
        && specialDate <= toDateObj;
    }).length;

    setCounts({ PLANNED: plannedCount, UNPLANNED: unplannedCount });
  };

  const handleFromDateChange = (date) => {
    setFromDate(date);
    calculateCounts(date, toDate);
  };

  const handleToDateChange = (date) => {
    setToDate(date);
    calculateCounts(fromDate, date);
  };

  const handleClose = () => {
    setFromDate('');
    setToDate('');
    setCounts({ PLANNED: 0, UNPLANNED: 0 });
    onClose();
  };

  useEffect(() => {
    if (!isOpen) {
      setFromDate('');
      setToDate('');
      setCounts({ PLANNED: 0, UNPLANNED: 0 });
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div style={{
      alignItems: 'center',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      bottom: 0,
      display: 'flex',
      justifyContent: 'center',
      left: 0,
      position: 'fixed',
      right: 0,
      top: 0,
      zIndex: 1000
    }}
    >
      <div style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        maxHeight: '90vh',
        maxWidth: '90%',
        overflow: 'auto',
        padding: '30px',
        width: '600px'
      }}
      >
        <h2 style={{
 fontWeight: 'bold', marginBottom: '20px', marginTop: 0, textAlign: 'center'
}}
        >
          Special Hours Report
        </h2>

        <div className="ncss-row mt4-sm">
          <div className="ncss-col-sm-6" style={{ textAlign: 'center' }}>
            <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>From</div>
            <DateInput
              value={fromDate}
              onChange={handleFromDateChange}
            />
          </div>
          <div className="ncss-col-sm-6" style={{ textAlign: 'center' }}>
            <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>To</div>
            <DateInput
              value={toDate}
              onChange={handleToDateChange}
            />
          </div>
        </div>

        {(fromDate && toDate) && (
          <div className="mt4-sm">
            <table className="ncss-table" style={{ borderCollapse: 'collapse', width: '100%' }}>
              <thead>
                <tr style={{ backgroundColor: '#f5f5f5' }}>
                  <th style={{
 borderBottom: '2px solid #ddd', fontWeight: 'bold', padding: '12px', textAlign: 'left'
}}
                  >Type
                  </th>
                  <th style={{
 borderBottom: '2px solid #ddd', fontWeight: 'bold', padding: '12px', textAlign: 'left'
}}
                  >Count
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ borderBottom: '1px solid #ddd', padding: '12px' }}>PLANNED</td>
                  <td style={{ borderBottom: '1px solid #ddd', padding: '12px' }}>{counts.PLANNED}</td>
                </tr>
                <tr>
                  <td style={{ borderBottom: '1px solid #ddd', padding: '12px' }}>UNPLANNED</td>
                  <td style={{ borderBottom: '1px solid #ddd', padding: '12px' }}>{counts.UNPLANNED}</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}

        <div style={{ marginTop: '20px', textAlign: 'center' }}>
          <ButtonBlack label="Close" onClick={handleClose} />
        </div>
      </div>
    </div>
  );
};

SpecialHoursReport.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  specialHours: PropTypes.arrayOf(PropTypes.shape({
    date: PropTypes.string,
    type: PropTypes.string,
  })).isRequired,
};

export default SpecialHoursReport;
